import {toInt} from '@/library/math';
import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';

const ContactEntryView = () => import('../../views/contact/ContactEntryView.vue');
const ContactEntryEdit = () => import('../../views/contact/ContactEntryEdit.vue');
const ContactIndex = () => import('../../views/contact/ContactIndex.vue');
const CustomerListNew = () => import('../../views/customer/CustomerListNew.vue');
const CustomerMap = () => import('../../views/customer/CustomerMap.vue');

const meta: MetaData = {
    module: 'customer',
};

let routes: RouteRecordRaw[] = [
    {
        name: 'customer-list',
        path: '/customer/entry/list',
        meta,
        component: ContactIndex,
    },
    {
        name: 'customer-map',
        path: '/customer/entry/map',
        meta,
        component: CustomerMap,
    },
    {
        name: 'customer-new-list',
        path: '/customer/entry/new-customer-list',
        meta,
        component: CustomerListNew,
    },
    {
        name: 'customer-entry-view',
        path: '/customer/entry/view/:id',
        alias: '/customer/entry/view/id/:id',
        meta,
        component: ContactEntryView,
        props(route: RouteLocationStringParam)
        {
            return {id: toInt(route.params.id)};
        },
    },
    {
        name: 'customer-entry-edit',
        path: '/customer/entry/edit/:id(\\d+)?',
        alias: '/customer/entry/edit/id/:id(\\d+)?',
        meta,
        component: ContactEntryEdit,
        props(route: RouteLocationStringParam)
        {
            return {id: toInt(route.params.id)};
        },
    },
    {
        path: '/customer/entry/:wildcard*',
        redirect: {name: 'customer-entry-list'},
    },
];

export default routes;
